import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useUnit } from 'effector-react';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { setCustomizerPreviewModeEvent } from '@nx-frontend/shared/store/customizer-preview-store';
import { $isOwner } from '@nx-frontend/shared/store/org-role';
import { $orgId, $portalId, $workspaceId } from '@nx-frontend/shared/store/portal-app';

export const PortalIsReadyPopup: React.FC = () => {
  const [isOwner, portalId, orgId, workspaceId] = useUnit([$isOwner, $portalId, $orgId, $workspaceId]);
  const [closeModal, setCustomizerPreviewMode] = useUnit([closeModalEvent, setCustomizerPreviewModeEvent]);
  const t = useTranslations('customizer');
  const router = useRouter();

  const handleBackClick = useCallback(() => {
    closeModal();
    if (isOwner) {
      router.push(`/dashboard/${orgId}/space/${workspaceId}`);
    } else {
      router.push(`/space/${workspaceId}/all`);
    }
  }, [closeModal, isOwner, orgId, router, workspaceId]);

  const handleEditPortal = useCallback(() => {
    router.push(`/portal/${portalId}/visual`);
    closeModal();
    setCustomizerPreviewMode({ type: 'default' });
  }, [portalId, router, closeModal, setCustomizerPreviewMode]);

  return (
    <div className="w-[360px] pb-1">
      <div className="flex justify-center mt-1 mb-3.5">
        <div className="flex justify-center items-center size-10 rounded-full bg-green-100">
          <Icon icon={IconsMap.CHECK_CIRCLE_FILL} className="size-5 text-green-700" />
        </div>
      </div>
      <div className="px-1.5">
        <div className="text-neutral-800 font-semibold text-lg text-center mb-1.5">
          {t('customizer-portal-is-ready-title')}
        </div>
        <div className="text-neutral-500 text-sm text-center mb-3.5">{t('customizer-portal-is-ready-text')}</div>
      </div>
      <div className="flex flex-row justify-between">
        <Button
          onClick={handleBackClick}
          type={ButtonType.STROKED}
          size={ButtonSize.XL}
          className="w-[170px] mt-4 !text-[13px]"
        >
          {isOwner
            ? t('customizer-portal-is-ready-back-to-dashboard')
            : t('customizer-portal-is-ready-back-to-internal')}
        </Button>
        <Button
          onClick={handleEditPortal}
          type={ButtonType.PRIMARY}
          size={ButtonSize.XL}
          className="w-[170px] mt-4 !text-[13px]"
        >
          {t('customizer-portal-is-ready-edit')}
        </Button>
      </div>
    </div>
  );
};
